import config from '@plone/volto/registry';
import './style.css';

/** @param {HTMLIFrameElement} target */
function updateIframeSize(target) {
  // Incase the iframe ends up failing same-origin policy check for some reason
  let iframeDocument = null;
  try {
    iframeDocument = target.contentDocument || target.contentWindow.document;
  } catch {
    return;
  }
  const newHeight = iframeDocument.querySelector('body').scrollHeight;
  target.height = newHeight;
}

export function EmbedContentView(props) {
  const { location, content } = props;
  const iframeSrc = `${location.pathname}/@@embedcontents/${content.index_file}`;
  const EmbedContentViewWrapper = config.getComponent('EmbedContentViewWrapper')
    .component;

  return (
    <EmbedContentViewWrapper>
      <h1>{content.title}</h1>
      <iframe
        src={iframeSrc}
        title={`${content.title} page contents`}
        className="embed-content-frame"
        onLoad={(event) => {
          updateIframeSize(event.target);
        }}
      />
    </EmbedContentViewWrapper>
  );
}
